<template>
  <div>
    <b-row class="mb-2" v-for="(conf, index) in itemConf" :key="index">
      <b-col sm="2" >{{ forUser && isLeaf(conf) && conf.__Value__.__desc__ ? conf.__Value__.__desc__ : conf.__Key__ }} <i class="i-type" v-if="isArray(conf)">[{{ conf.__Value__.length }}]</i></b-col>
      <b-col v-if="isArray(conf)">
        <span v-for="(c, index) in conf.__Value__" :key="index">
          <conf-field v-if="isLeaf(c)" :conf="c.__Value__" :useDefault="useDefault" :userPerm="userPerm"
                      :strict="strict" :notData="notData" />
          <confnode v-else :items.sync="c" :useDefault="useDefault" :forUser="forUser" :userPerm="userPerm"
                    :strict="strict" :notData="notData" />
        </span>
      </b-col>
      <b-col v-else-if="isLeaf(conf)">
        <conf-field :conf="conf.__Value__" :useDefault="useDefault" :userPerm="userPerm"
                    :strict="strict" :notData="notData" />
      </b-col>
      <b-col v-else>
        <confnode :items.sync="conf" :useDefault="useDefault" :forUser="forUser" :userPerm="userPerm"
                  :strict="strict" :notData="notData" />
      </b-col>
      <b-col v-if="addable" sm="2">
        <b-button size="sm" class="mr-2" variant="outline-danger"
                  @click="removeItem(conf.__Key__)">
          <span class="fa fa-minus" />
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-2" v-if="addable">
      <b-col sm="2">
        <b-button size="sm" class="mr-2" variant="outline-success" @click="addItem">
          <span class="fa fa-plus" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import utils from '@/utils/utils'
import ConfField from '@/components/Conffield'

export default {
  name: 'confnode',
  props: ['items', 'useDefault', 'userPerm', 'forUser', 'strict', 'previewing', 'notData'],
  components: {
    ConfField
  },
  computed: {
    addable: function () {
      return Object.keys(this.items).indexOf('__Addable__') !== -1
    },
    itemConf: function () {
      let itemConfs = utils.isUndefined(this.items.__Value__) ? this.items : this.items.__Value__
      let treeConf = []
      if (utils.isUndefined(itemConfs.__tree__)) {
        treeConf = Object.keys(itemConfs).map((field) => {
          return {node: field, children: null}
        })
      } else {
        treeConf = itemConfs.__tree__
      }
      let itemKeys = []
      treeConf.map((root) => {
        this.treeTraverse(root, itemKeys, itemConfs)
      })
      return itemKeys.map((field) => {
        return itemConfs[field]
      })
    }
  },
  methods: {
    isLeaf (node) {
      return !!node.__Value__.__type__
    },
    isArray (node) {
      return node.__Value__ instanceof Array
    },
    removeItem (confKey) {
      this.$delete(this.itemConf, confKey)
      this.$emit(
        'update:items', this.items
      )
    },
    addItem () {
      let field = prompt('请输入新参数名字', '')
      if (field) {
        if (Object.keys(this.itemConf).indexOf(field) !== -1) {
          this.$message.error('参数已存在')
        } else {
          this.itemConf[field] = {
            __Index__: 0,
            __Key__: field,
            __Tag__: null,
            __Value__: utils.copyObject(this.items['__Addable__'])
          }
          this.$forceUpdate()
        }
      }
    },
    treeTraverse (root, itemKeys, items) {
      itemKeys.push(root.node)
      if (root.children && root.children.length && this.isLeaf(items[root.node])) {
        let nextRoots = utils.findInArray(
          root.children, items[root.node].__Value__.__value__, '__Value__', '__Key__'
        )
        if (nextRoots) {
          nextRoots.map((nextRoot) => {
            this.treeTraverse(nextRoot, itemKeys, items)
          })
        } else if (root.__default__) {
          root.__default__.map((nextRoot) => {
            this.treeTraverse(nextRoot, itemKeys, items)
          })
        }
      }
    }
  }
}
</script>

<style>
  .i-type {
    color: #999;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// Confnode.vue?6b1dfb04